import React from 'react';
import { Box, Card, Grid2 as Grid, Skeleton } from "@mui/material";

export const PlaceCardSkeleton = () => {
    return (
        <Card
            elevation={4}
            sx={{
                margin: 2,
                padding: 0,
                borderRadius: 3,
                overflow: "hidden",
                bgcolor: "background.paper"
            }}
        >
            {/* Image Skeleton */}
            <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                    width: "100%",
                    height: 210,
                    aspectRatio: "16 / 9",
                    display: "block"
                }}
            />

            {/* Content Skeleton */}
            <Box sx={{ p: 1.5 }}>
                {/* Title Skeleton */}
                <Skeleton
                    variant="text"
                    animation="wave"
                    width="65%"
                    height={32}
                    sx={{ mb: 1, borderRadius: 1 }}
                />

                {/* Info / Badge Row */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", my: 1 }}>
                    <Skeleton variant="rounded" animation="wave" width="30%" height={22} sx={{ borderRadius: 1.5 }} />
                    <Skeleton variant="rounded" animation="wave" width="25%" height={22} sx={{ borderRadius: 1.5 }} />
                </Box>

                {/* Subtitle / Location */}
                <Skeleton
                    variant="text"
                    animation="wave"
                    width="85%"
                    height={20}
                    sx={{ my: 0.8, borderRadius: 0.5 }}
                />

                {/* Divider Line */}
                <Box sx={{ height: "1px", bgcolor: "divider", my: 1 }} />

                {/* Price Row */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pt: 0.5 }}>
                    <Skeleton variant="text" animation="wave" width="20%" height={24} />
                    <Skeleton variant="rounded" animation="wave" width="35%" height={28} sx={{ borderRadius: 1 }} />
                </Box>
            </Box>
        </Card>
    );
};

export const PlaceListSkeleton = ({ count = 6 }) => {
    return (
        <Grid container direction="row" justifyContent="center" alignItems="center">
            {Array.from({ length: count }).map((_, index) => (
                <Grid key={"place-skel-" + index} size={{ xs: 12, sm: 6, md: 4, lg: 3 }} sx={{ width: "100%" }}>
                    <PlaceCardSkeleton />
                </Grid>
            ))}
        </Grid>
    );
};

export default PlaceCardSkeleton;
